import { Map } from 'immutable';

import { shapeKeywordsForAPI } from '../product/shapeAttributes';

import { OPERATIONS } from '../../constants/product';

export function editKeywords({ product, value }) {
  const channel = product.get('channel');

  return {
    product: product.set('keywords', value),
    operations: [
      Map({ type: OPERATIONS[channel].KEYWORDS, value: shapeKeywordsForAPI({ channel, value }) }),
    ],
  };
}
